import API from '../../../../../helpers/request/api';

const api = () => new API();

const load = (postId) => {
  const query = {
    query: `{
      post(id: ${postId}){
        description
      }
    }`,
  };

  return api().get(query);
};

export default {
  load,
};



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Description/queries/descriptions.js